import { useState, useRef } from "react";
import { motion } from "framer-motion";
import { MoveHorizontal } from "lucide-react";
import { BEFORE_AFTER } from "@/data/testimonials";

const Slider = ({ item }) => {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);

  const move = (clientX) => {
    const rect = ref.current.getBoundingClientRect();
    const p = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, p)));
  };
  const onDown = () => { dragging.current = true; };
  const onUp = () => { dragging.current = false; };
  const onMove = (e) => { if (dragging.current) move(e.touches ? e.touches[0].clientX : e.clientX); };

  return (
    <div className="border-2 border-[#0A1A4A] shadow-hard bg-white" data-testid="before-after-item">
      <div
        ref={ref}
        className="relative h-72 overflow-hidden select-none cursor-ew-resize"
        onMouseDown={onDown} onMouseUp={onUp} onMouseLeave={onUp} onMouseMove={onMove}
        onTouchStart={onDown} onTouchEnd={onUp} onTouchMove={onMove}
      >
        <img src={item.after} alt={`${item.title} after — ${item.area}`} className="absolute inset-0 w-full h-full object-cover pointer-events-none" draggable={false} />
        <span className="absolute top-3 right-3 z-10 bg-[#2563EB] text-white font-mono-accent text-[10px] tracking-widest uppercase px-2 py-1 border border-[#0A1A4A]">After</span>
        <div className="absolute inset-0 overflow-hidden pointer-events-none" style={{ width: `${pos}%` }}>
          <img src={item.before} alt={`${item.title} before — ${item.area}`} className="absolute inset-0 h-full object-cover" style={{ width: `${10000 / pos}%`, maxWidth: "none" }} draggable={false} />
          <span className="absolute top-3 left-3 bg-[#0A1A4A] text-white font-mono-accent text-[10px] tracking-widest uppercase px-2 py-1 border border-white">Before</span>
        </div>
        <div className="absolute top-0 bottom-0 z-20 -ml-5 flex items-center pointer-events-none" style={{ left: `${pos}%` }}>
          <div className="w-0.5 h-full bg-white shadow-[0_0_0_1px_#0A1A4A]" />
          <div className="absolute w-10 h-10 -ml-5 rounded-full bg-white border-2 border-[#0A1A4A] flex items-center justify-center">
            <MoveHorizontal size={18} className="text-[#0A1A4A]" />
          </div>
        </div>
      </div>
      <div className="p-5 flex items-center justify-between border-t-2 border-[#0A1A4A]">
        <span className="font-display font-extrabold uppercase text-[#0A1A4A]">{item.title}</span>
        <span className="font-mono-accent text-[11px] tracking-widest uppercase text-[#2563EB]">{item.area}</span>
      </div>
    </div>
  );
};

export const BeforeAfter = () => (
  <section id="work" className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20 sm:py-28">
    <div className="mb-12 max-w-2xl">
      <div className="font-mono-accent text-xs tracking-widest uppercase text-[#2563EB] mb-3">/ Recent Work</div>
      <h2 className="font-display font-black text-[#0A1A4A] text-4xl sm:text-6xl tracking-tight leading-[0.95]">
        BEFORE.<br /><span className="text-[#2563EB]">AFTER.</span> SORTED.
      </h2>
      <p className="text-[#0A1A4A]/70 mt-5">Drag the slider to see the difference. Real jobs, done properly, across Swansea &amp; Gower.</p>
    </div>
    <div className="grid md:grid-cols-3 gap-6">
      {BEFORE_AFTER.map((item, i) => (
        <motion.div key={item.title} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}>
          <Slider item={item} />
        </motion.div>
      ))}
    </div>
  </section>
);
